<template>
  <div class="search-header">
    <GridContainer>
      <GridItem class="search-header-wrapper">
        <div class="text-container">
          <h4>
            <NuxtLink href="/blog">{{ t("subtitle") }}</NuxtLink>
          </h4>
          <h1>
            <NuxtLink href="/blog">{{ t("title") }}</NuxtLink>
          </h1>
          <p>
            {{ t("description") }}
          </p>
        </div>
        <div class="form-container">
          <TextInput
            :placeholder="t('input.search.placeholder')"
            :model-value="searchTerm"
            @update:model-value="(v) => $emit('update:searchTerm', v)"
          />
        </div>
      </GridItem>
    </GridContainer>
  </div>
</template>

<script lang="ts" setup>
import { GridContainer, GridItem, TextInput } from "cja-phoenix";

const { t } = useI18n();

const props = defineProps<{
  search?: string;
}>();

const searchTerm = ref(props.search || "");

defineEmits(["update:searchTerm"]);
</script>

<style lang="scss" scoped>
.search-header {
  padding: 24px 0;
  background: linear-gradient(80deg, $extra-light-blue 1%, $white 100%);

  @media screen and (min-width: $break-lg-min) {
    padding: 40px 0;
  }

  .search-header-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media screen and (min-width: $break-md-min) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 24px;
    }
  }

  .text-container {
    max-width: 640px;

    h4 {
      font-size: 20px;
      line-height: 24px;
      font-weight: 700;
      margin: 0 0 16px;

      a {
        color: inherit;
        text-decoration: none;
      }
    }

    h1 {
      font-size: 30px;
      line-height: 34px;
      font-weight: 800;
      margin: 0;
      @include text-gradient-dark-blue;

      @media screen and (min-width: $break-lg-min) {
        font-size: 36px;
        line-height: 42px;
      }

      @media screen and (min-width: $break-xl-min) {
        margin: 0 0 16px;
      }
    }

    p {
      font-size: 16px;
      line-height: 22px;
      margin: 0;

      @media screen and (max-width: $break-lg-max) {
        display: none;
      }
    }
  }

  .form-container {
    max-width: 400px;
    width: 100%;
  }
}
</style>

<i18n lang="json">
{
  "pt": {
    "subtitle": "Blog",
    "title": "Tempo & Dinheiro",
    "description": "Dicas, artigos e ferramentas para gerir as tuas finanças pessoais de forma inteligente.",
    "input": {
      "search": {
        "placeholder": "Pesquisa um tópico"
      }
    }
  }
}
</i18n>
